import { useMemo } from 'react';
import { format } from 'date-fns';
import type { OperationDto } from '@/shared/types';

export const useGroupOperationsByDate = (operations: OperationDto[]) => {
  const groupedOperations = useMemo(() => {
    return operations.reduce<Record<string, OperationDto[]>>(
      (acc, operation) => {
        const date = new Date(operation.date);

        const key = format(date, 'yyyy-MM');

        acc[key] ??= [];
        acc[key].push(operation);

        return acc;
      },
      {}
    );
  }, [operations]);

  return {
    groupedOperations,
  };
};
